import { createStore} from "vuex";

export default createStore({
    state:{
        user: {
            user_id: false,
            username: '', 
            auth_key: '',
            email:'',
            role:{
                item_name:'guest'
            },
            name:'',
            isLogged: false,
            bearer: '$2y$13$7TIMNG/PCoUG4zpAkRHTDuS1b/0HbfCRfIkOm0A/I1.sy7R8ztpvy$2y$13$7TIMNG/PCoUG4zpAkRHTDuS1b/0HbfCRfIkOm0A/I1.sy7R8ztpvy',
        },
        isMobile: false,
        role: null,
        apiUrl: `https://feedback.agl.center/ApiConnector.php`,
        apiDomain: 'https://api.feedback.agl.center/',
        flash_messsage: {
            title: '',
            massage: '',
            type: ''
        },
        dateLastActive: 0,
    },
    mutations:{
        setUser(state, user){
            state.user = user
        },
        setUserData(state, user){

            if(user.id)               { state.user.user_id = user.id}
            if(user.bearer)           { state.user.bearer = user.bearer}
            if(user.username)         { state.user.username = user.username}
            if(user.auth_key)         { state.user.auth_key = user.auth_key}
            if(user.tg)               { state.user.tg = user.tg}
            if(user.email)            { state.user.email = user.email}
            if(user.role)             { state.user.role = user.role}
            if(user.profile)          { state.user.profile = user.profile}
        },
        setLogged(state, logged){
            state.user.isLogged = logged
        },
        setrole(state, role){
            state.role = role
        },
        setIsMobile(state, isMobile){
            state.isMobile = isMobile
        },
        setFlashMessage(state, flashMessage) {
            state.flash_messsage = flashMessage
        }
    },
    getters:{
        getUser:state => {

            return state.user
        },
        getIsMobile:state => {

            return state.isMobile
        },
        getApiUrl:state => {

            return state.apiUrl
        },
        getApiDomain:state => {

            return state.apiDomain
        },
        getFlashMessage:state => {
            return state.flash_messsage
        }
    },
})